<template>
  <div id="orderReturn">

    <div class="orderReturn-div" style="height: 100%">
      <custom-table ref="customTable" :customOptions="customOptions" :columns="columns"
                    addText="">

        <template slot="search-bottom">
          <div style="margin-bottom: 16px">
            <span style="font-weight: bold">部分退票</span>
            <span
                style="color: #666666">:可选择部分乘客进行退票操作。如开启退票规则，根据所选乘客合计实付金额进行计算退票手续费。</span>
          </div>
        </template>
        <template slot-scope="{ item, row }">
          <div v-if="item.prop === 'created'">{{
              row.created | filterTime
            }}
          </div>
          <div v-else-if="item.prop == 'status'">
            <el-tag size="mini" :type="row.status | filterOrderStatusType">{{ row.status | filterOrderStatus }}</el-tag>
          </div>
          <template v-else-if="item.prop === 'loadType'">{{ row.loadType | filterConst('LOADTYPE') }}
          </template>
          <div v-else-if="item.prop == 'channelAlias'">
            <span v-if="mixinUserInfo.platformType === 1">{{ row[item.prop] | filterConst("CHANNELALIAS") }}</span>
            <span v-if="mixinUserInfo.platformType === 2">{{ row[item.prop] | filterConst("CHANNELALIAS2") }}</span>
          </div>
          <template v-else-if="item.prop == 'startLineTime'">
            {{ row.schedulingTime | filterTime("MM-DD") }}
            {{ row.startLineTime }}
          </template>
          <template v-else-if="item.prop == 'startStationName'">
            <span style="font-weight: 600">{{ row.startStationName }} - {{ row.endStationName }}</span>
          </template>
          <template v-else-if="item.prop == 'passengerNum'">
            <el-button type="text" style="text-decoration: underline;" @click="handleConnectionSearch(row)">
              {{ row.passengerNum }}
            </el-button>
          </template>
          <div v-else>{{ row[item.prop] ? row[item.prop] : "-" }}
          </div>
        </template>
        <template slot="table-operation">
          <el-table-column label="操作" width="70" fixed="right" align="center">
            <div slot-scope="{ row }" class="flex-center">
              <div v-if="(row.passengerNum === 1 || row['channelAlias'] != 'system_order')  && row['channelAlias'] != 'station_order'">
                <el-button type="text" v-if="row.status<=10"
                           @click="cancelClick(row)">退票
                </el-button>
              </div>
              <div v-else>
                <el-button v-if="row['channelAlias'] == 'system_order'" type="text"
                           slot="reference"
                           @click="cancelPartClick(row)">退票
                </el-button>
              </div>
            </div>
          </el-table-column>
        </template>
      </custom-table>

    </div>


    <el-dialog append-to-body title="乘客信息" :visible.sync="orderCustomersShow" width="750px"
               @close="orderCustomersShow = false;showPart = false">
      <el-table :data="orderCustomers" stripe border style="margin-bottom: 20px;"
                @selection-change="handleSelectionChange">
        <el-table-column
            v-if="showPart"
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column prop="customerName" label="乘客姓名" width="140" v-slot="{ row }">
          {{ row.customerName }}
          <el-tag v-if="row.isDefault == 1" effect="plain">联系人</el-tag>
        </el-table-column>
        <el-table-column prop="idCard" label="乘客身份证"></el-table-column>
        <el-table-column prop="customerPhone" label="乘客电话" width="120"></el-table-column>
        <el-table-column prop="ticketType" label="车票类型" width="100" v-slot="{row}"
                         v-if="mixinUserInfo.platformType === 2">
          {{ ['全票', '半价票', '免票(占座)', '免票(不占座)'][row.ticketType - 1] }}
        </el-table-column>
        <el-table-column width="80" show-overflow-tooltip v-if="mixinUserInfo.platformType === 2" prop="ticketNo"
                         label="票号"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" v-if="showPart">
        <el-button @click="orderCustomersShow = false;showPart = false">取 消</el-button>
        <el-button type="primary" @click="clickPartFn" :disabled="!orderSelectList.length">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog append-to-body title="退票说明" :visible.sync="refundState" width="330px"
               @close="isCustomRule = false; refundFee = null">
      <div :class="{ 'text-disabled': isCustomRule }">
        <div class="cancel-money" v-for="(item, index) in refundRules" :key="index">
          {{ index + 1 }}.检票/接人时间{{ item.timeNum }}{{ item.timeType == 1 ? "小时" : "分钟" }}内办理退票的，按支付金额{{
            item.refundFee
          }}%收取退票费
        </div>
        <div class="cancel-money flex-between" style="padding-top: 20px">
          <div class="cancel-money-title">票面金额</div>
          <div class="util-money">￥{{ refundFeeObj.orderFee }}</div>
        </div>

        <div class="cancel-money flex-between">
          <div class="cancel-money-title">实付金额</div>
          <div>
            <span v-if="refundFeeObj.couponFee">优惠券-￥{{ refundFeeObj.couponFee }}</span>
            <span class="util-money">￥{{ refundFeeObj.realFee }}</span>
          </div>
        </div>

        <div class="cancel-money flex-between">
          <div class="cancel-money-title">退票费用</div>
          <div>
            <span v-if="refundFeeObj.refundProportion">退票费率{{ refundFeeObj.refundProportion }}%</span>
            <span class="util-money">￥{{ refundFeeObj.retreatFee }}</span>
          </div>
        </div>
        <div class="cancel-money flex-between">
          <div class="cancel-money-title">实际退款</div>
          <div class="cancel-money-money util-money">
            ￥{{ refundFeeObj.refundFee }}
          </div>
        </div>
      </div>

      <hr style="margin:20px 0">

      <div>
        <div style="display:flex;align-items:center;margin-bottom:10px">
          <el-checkbox v-model="isCustomRule"></el-checkbox>
          <p @click="isCustomRule = !isCustomRule" style="cursor: pointer;margin-left:10px">自定义退票手续费</p>
        </div>
        <el-input v-model="refundFee" placeholder="请输入要扣除的费用" :disabled="!isCustomRule"
                  @input="() => refundFee = refundFee.replace(/^0[\d]/g, '0').replace(/^[1-9][0-9]{4,}/g, '9999').replace(/(\d\d{0,3}\.?\d{0,2})?.*/g, '$1')"></el-input>
        <p style="margin-top:10px;font-size: 14px;color:red">注意：手续费不能大于实际支付金额，可输入0</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelConfirm" :loading="loading">确 认</el-button>
        <el-button @click="refundState = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "orderReturn",
  data() {
    return {
      // 配置项
      orderCustomers: [],
      orderCustomersShow: false,
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/order',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          orderType: 4,
          status: 10
        },
        search: [
          {
            type: "select", field: "channelAlias", name: "订单来源", value: '',
            clearable: false,
            option: [
              {value: 'system_order', label: '窗口售票'},
              {value: 'channel_fast_order', label: '极速购票'},
              {value: 'channel_wechat', label: '小程序'},
              {value: 'channel_driver_order', label: '司机'},
            ]
          },
          {type: "input", field: "customerName", name: "联系人", value: ""},
          {type: "input", field: "customerPhone", name: "联系电话", value: ""},
          {
            type: "select", field: "lineId", name: "搜索线路", value: null,
            filterable:true,
            props: {label: 'stationName', value: 'id',},
            option: []
          },

          {
            type: "select", field: "ticketSellerId", name: "售票员", value: null,
            props: {label: 'name', value: 'id',},
            option: []
          },
          {
            type: "input", field: "ticketNo", name: "票号", value: null,
          }

        ],
      },
      // 表头
      columns: [
        {prop: "orderNo", label: "订单号", width: 200},
        {prop: "ticketNo", label: "票号", width: 105},
        {prop: "ticketSeller", label: "售票员", width: 75},
        {prop: "status", label: "订单状态", width: 70},
        {prop: "loadType", label: "检票状态", width: 70},
        {prop: "channelAlias", label: "订单来源", width: 70},

        {prop: "created", label: "下单时间", width: 130},
        {prop: "startStationName", label: "线路名称", minWidth: 180},
        {prop: "startLineTime", label: "班次", width: 90},
        {prop: "customerName", label: "乘客", width: 70},
        {prop: "idCard", label: "身份证", width: 150},
        {prop: "customerPhone", label: "联系电话", width: 110},
        {prop: "passengerNum", label: "乘客数", width: 60},
        {prop: "lineFee", label: "车票价格", width: 70},
        {prop: "realFee", label: "实付金额", width: 70},
      ],
      refundRules: [],
      refundFeeObj: {},
      refundState: false,
      isCustomRule: false,
      refundFee: '',
      loading: false,
      showPart: false,
      orderSelectList: []
    }
  },
  created() {
    this.customOptions.params.platformType = this.mixinUserInfo.platformType
  },
  methods: {
    // 查看乘客
    async handleConnectionSearch(row) {
      let url = "/api/v1/manage/order/orderCustomer/customer/" + row.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        if (data.data.length == 0) {
          this.$message.warning("没有找到相关乘客");
        } else {
          this.orderCustomers = data.data;
          this.orderCustomersShow = true;
        }
      }
    },
    async cancelConfirm() {
      if (this.isCustomRule) {
        if (this.refundFee.trim() == '') {
          this.$message.warning({
            message: '请输入要扣除的费用'
          });
          return;
        }
      }
      this.loading = true;
      if (this.showPart) {
        await this.postCancel2();
      } else {
        await this.postCancel();
      }

      this.loading = false;
    },
    /* 取消订单 */
    async cancelClick(row) {
      this.order = row;
      let res = await this.getRefundFeeObj();
      if (!res) {
        return;
      }
      await this.getRefundRules();
      if (this.refundRules && this.refundRules.length > 0) {
        this.refundState = true;
      } else {
        this.$confirm("确认要取消本订单吗?", "退票提示").then(async () => {
          this.postCancel();
        });
      }
    },
    // 部分退票
    cancelPartClick(row) {
      this.showPart = true
      this.order = row
      this.handleConnectionSearch(row)
    },
    async clickPartFn() {
      let url = "/api/v1/manage/order/getRefundFee/portion/" + this.order.id;
      let data = await this.$axios.get(url, {
        orderCustomerId: this.orderSelectList.map((item) => (item.id)).toString()
      });
      if (data && data.code == 1) {
        this.refundFeeObj = data.data || [];
        this.refundState = true
      }
    },

    handleSelectionChange(row) {
      this.orderSelectList = row
    },
    async postCancel2() {
      let params = {};
      if (this.isCustomRule) {
        params.refundFee = this.refundFee;
      }
      let url = "/api/v1/manage/order/station/cancel/" + this.order.id;
      let data = await this.$axios.post(url, {
        ...params,
        orderCustomerId: this.orderSelectList.map((item) => (item.id)).toString()
      });
      if (data && data.code == 1) {
        this.$message.success("操作成功");
        this.$refs.customTable.listFn();
        this.refundState = false;
        this.orderCustomersShow = false
        this.showPart = false
      }
    },
    async postCancel() {
      let params = {};
      if (this.isCustomRule) {
        params.refundFee = this.refundFee;
      }
      let url = "/api/v1/manage/order/cancel/" + this.order.id;
      let data = await this.$axios.post(url, params);
      if (data && data.code == 1) {
        this.$message.success("操作成功");
        this.$refs.customTable.listFn();
        this.refundState = false;
      }
    },
    async getRefundRules() {
      let url = "/api/v1/manage/order/refund/" + +this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.refundRules = data.data || [];
      }
    },
    async getRefundFeeObj() {
      let url = "/api/v1/manage/order/getRefundFee/" + +this.order.id;
      let data = await this.$axios.get(url);
      if (data && data.code == 1) {
        this.refundFeeObj = data.data || [];
        return true;
      } else {
        return false;
      }
    },
  }
}
</script>

<style scoped lang="less">
#orderReturn {
  width: 100%;
  position: fixed;
  height: calc(100% - 48px) !important;
  top: 48px;
  left: 0;
  box-sizing: border-box;
  background-color: #f3f4f5;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 40px;


  & > .orderReturn-div {
    width: 1000px;
    margin-top: 20px;
    padding: 20px;
    border-radius: 20px;
    background-color: white;
    position: relative;

    .tips {
      background-color: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 134px;
      right: -110px;
      width: 100px;
      color: #666666;
      padding: 12px;
      box-sizing: border-box;
      border-radius: 10px;

      img {
        width: 100%;
      }
    }
  }

  .orderReturn-header {
    font-size: 24px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      margin-right: 5px;
    }

    &:hover {
      color: #666;
    }
  }

  .cancel-money{
    width: 100%;
  }
}

</style>